<template>
    <Conversion :src="logoSrc"
        :payload="payload"
        :name="form.first_name"
        :logo-src="logoSrc"
        @error="handleError"
    />
</template>

<script>
import Conversion from "./Conversion.vue";

export default {
    components: {Conversion},
    props: {
        logoSrc: {
            type: String,
            required: true
        },
        pageLocation: {
            type: String,
            required: true
        },
        form: {
            type: Object,
            required: true
        },
    },
    methods: {
        handleError(error) {
            this.$emit('error', error);
        }
    },

    computed: {
        payload() {
            return {
                country: this.form.country,
                region_id: this.form.selectedLocation.region_id,
                criteria_id: this.form.selectedLocation.criteria_id,
                city: this.form.city,
                postcode: this.form.postcode,
                issue: this.form.issue,
                first_name: this.form.first_name,
                last_name: this.form.last_name,
                phone: (this.form.phone).replace(/\D/g, ""),
                phone_alt: this.form.phone_alt,
                email: this.form.email,
                language_bcp47: this.form.language_bcp47 ?? window.navigator.language,
                language_iso639_1: this.form.languageCode,
                intake_type: this.form.intake_type ? this.form.intake_type : 'conversation',
                intake_capture_id: this.form.intake_capture_id,
                intake_version: this.form.intake_version,
                intake_method: this.form.intake_method ? this.form.intake_method : 'text_convo',
                intake_areaoflaw_agent: this.form.intake_areaoflaw_agent,
                intake_jurisdiction_agent: this.form.intake_jurisdiction_agent,
                intake_issue: this.form.intake_issue,
                intake_summary: this.form.intake_summary,
                intake_transcript: this.form.intake_transcript,
                intake_transcript_structured: this.form.intake_transcript_structured,
                intake_reasoning: this.form.intake_reasoning,
                intake_price_range_start: this.form.intake_price_range_start || null,
                intake_price_range_end: this.form.intake_price_range_end || null,
                intake_pricing_snapshot: this.form.intake_pricing_snapshot || null,
                overriding_question: this.form.overriding_question,
                overridden_division_slug: this.form.overridden_division_slug,
                preflight_tenant_id: this.form.preflight_tenant_id ?? null,
                preflight_tenant_name: this.form.preflight_tenant_name ?? null,
                preflight_status: this.form.preflight_status ?? null,
                preflight_reason: this.form.preflight_reason ?? null,
                preflight_preferred_tenant_status: this.form.preflight_preferred_tenant_status ?? null,
                metadata: {
                    selected_location: this.form.selectedLocation.name,
                    sms_opted_in: this.form.sms_opted_in,
                    sms_able: true,
                    phone_type: this.form.phone_type,
                    page_location: this.pageLocation,
                    ga_client_id: window.SHARED.gaClientId,
                    ga_session_id: window.SHARED.gaSessionId
                }
            }
        }
    }
}
</script>
